import React, { useState, useEffect } from "react";
import axios from "axios";

const SendingForm = () => {
    const [activeTab, setActiveTab] = useState("suspension"); // Manage active tab state
    const [formData, setFormData] = useState({
        provider_name: "",
    });
    const [nearbyProviders, setNearbyProviders] = useState([
        { name: "", address: "", contact: "" },
    ]);
    const [liftProvider, setLiftProvider] = useState(""); // Lift tab provider name
    const [response, setResponse] = useState("");
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false); // Loading state
    const [customRecipients, setCustomRecipients] = useState(""); // Custom recipient emails
    const [sendingLogs, setSendingLogs] = useState([]);

    useEffect(() => {
      const savedLogs = JSON.parse(localStorage.getItem("sendingLogs")) || [];
      setSendingLogs(savedLogs);
    }, []);

    const handleTabChange = (tab) => setActiveTab(tab);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleProviderChange = (index, field, value) => {
        const updatedProviders = [...nearbyProviders];
        updatedProviders[index][field] = value;
        setNearbyProviders(updatedProviders);
    };

    const addProvider = () => {
        setNearbyProviders([...nearbyProviders, { name: "", address: "", contact: "" }]);

        setTimeout(() => {
            window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });

            const nameInputs = document.querySelectorAll(".provider-name-input");
            if (nameInputs.length > 0) {
                nameInputs[nameInputs.length - 1].focus();
            }
        }, 100);
    };

    const removeProvider = (index) => {
        const updatedProviders = nearbyProviders.filter((_, i) => i !== index);
        setNearbyProviders(updatedProviders);
    };

    const validateSuspensionForm = () => {
        const newErrors = {};
        if (!formData.provider_name.trim()) {
            newErrors.provider_name = "Provider Name is required.";
        }
        nearbyProviders.forEach((provider, index) => {
            if (!provider.name.trim()) {
                newErrors[`provider_name_${index}`] = `Provider ${index + 1} Name is required.`;
            }
            if (!provider.address.trim()) {
                newErrors[`provider_address_${index}`] = `Provider ${index + 1} Address is required.`;
            }
            if (!provider.contact.trim()) {
                newErrors[`provider_contact_${index}`] = `Provider ${index + 1} Contact is required.`;
            }
        });
        return newErrors;
    };

    const handleSuspensionSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = validateSuspensionForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const confirmSubmission = window.confirm("Are you sure you want to send the suspension email?");
        if (!confirmSubmission) {
            return; // Exit if the user cancels the confirmation dialog
        }

        setLoading(true);
        setErrors({});
        setResponse("");

        const dynamicVariables = {
            provider_name: formData.provider_name,
            nearby_providers: nearbyProviders,
        };

        const recipients = ["dev@amaphil.com.ph", ...customRecipients.split(",").map(email => email.trim())].filter(email => email);

        try {
            const res = await axios.post(
                window.location.host.indexOf('localhost') >= 0 ? "http://localhost/react/mailgun/ajax/" : "https://allaccess.net.ph/mailgun/",
                {
                    from: "AMAPHIL Info <info@amaphil.com.ph>",
                    to: recipients.join(","),
                    subject: "AMAPHIL INFORMATION BULLETIN TO THE CORPORATE ACCOUNTS",
                    template: "amaphil_suspended_provider",
                    "h:X-Mailgun-Variables": dynamicVariables,
                    tbl_id: localStorage.tbl_id
                },
                { headers: { "Content-Type": "application/json" } }
            );

            setResponse(res.data.success ? "Suspension email sent successfully!" : "Failed to send the email.");
            const logEntry = {
              type: "Suspension",
              timestamp: new Date().toLocaleString(),
              recipient: recipients.join(", "),
              subject: "AMAPHIL INFORMATION BULLETIN TO THE CORPORATE ACCOUNTS",
              status: "Sent",
            };
            const updatedLogs = [...sendingLogs, logEntry];
            setSendingLogs(updatedLogs);
            localStorage.setItem("sendingLogs", JSON.stringify(updatedLogs));
        } catch (err) {
            setResponse("Error sending email. Check console for details.");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleLiftSubmit = async (e) => {
        e.preventDefault();

        if (!liftProvider.trim()) {
            setErrors({ liftProvider: "Provider Name is required for lifting suspension." });
            return;
        }

        const confirmSubmission = window.confirm("Are you sure you want to send the lift suspension email?");
        if (!confirmSubmission) {
            return; // Exit if the user cancels the confirmation dialog
        }

        setLoading(true);
        setErrors({});
        setResponse("");

        const dynamicVariables = {
            provider_name: liftProvider,
        };

        const recipients = ["developer@amaphil.com.ph", ...customRecipients.split(",").map(email => email.trim())].filter(email => email);

        try {
            const res = await axios.post(
                window.location.host.indexOf('localhost') >= 0 ? "http://localhost/react/mailgun/ajax/" : "https://allaccess.net.ph/mailgun/",
                {
                    from: "AMAPHIL Info <info@amaphil.com.ph>",
                    to: recipients.join(","),
                    subject: "AMAPHIL INFORMATION BULLETIN TO THE CORPORATE ACCOUNTS",
                    template: "amaphil_suspension_lift",
                    "h:X-Mailgun-Variables": dynamicVariables,
                    tbl_id: localStorage.tbl_id
                },
                { headers: { "Content-Type": "application/json" } }
            );

            setResponse(res.data.success ? "Lift suspension email sent successfully!" : "Failed to send the email.");
            const logEntry = {
              type: "Lift",
              timestamp: new Date().toLocaleString(),
              recipient: recipients.join(", "),
              subject: "AMAPHIL INFORMATION BULLETIN TO THE CORPORATE ACCOUNTS",
              status: "Sent",
            };
            const updatedLogs = [...sendingLogs, logEntry];
            setSendingLogs(updatedLogs);
            localStorage.setItem("sendingLogs", JSON.stringify(updatedLogs));
        } catch (err) {
            setResponse("Error sending email. Check console for details.");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleReset = () => {
        setFormData({ provider_name: "" });
        setNearbyProviders([{ name: "", address: "", contact: "" }]);
        setLiftProvider("");
        setCustomRecipients(""); // Reset custom recipients
        setErrors({});
        setResponse("");

        document.querySelectorAll("#provider_name")[0].focus()
    };

    return (
        <div className="container mt-5" style={{maxWidth: '700px'}}>
            <div className="row logo mb-4">
                <img alt={"AMAPHIL"} src={"https://amaphil.com.ph/wp-content/uploads/2024/12/amaphil-tap.png"} />
            </div>

            {response && (
                <div className="alert alert-info mt-4" role="alert">
                    <h4>Response:</h4>
                    <pre>{response}</pre>
                </div>
            )}

            <ul className="nav nav-tabs">
                <li className="nav-item">
                    <button
                        className={`nav-link ${activeTab === "suspension" ? "active" : ""}`}
                        onClick={() => handleTabChange("suspension")}
                    >
                        Suspension
                    </button>
                </li>
                <li className="nav-item">
                    <button
                        className={`nav-link ${activeTab === "lift" ? "active" : ""}`}
                        onClick={() => handleTabChange("lift")}
                    >
                        Lift
                    </button>
                </li>
            </ul>

            {activeTab === "suspension" && (
                <div className="tab-content mt-4">
                    <h3>Suspension Form</h3>
                    <form onSubmit={handleSuspensionSubmit}>

                        <div className="mb-3">
                            <label htmlFor="custom_recipients" className="form-label">
                                Custom Recipients (comma-separated emails, <b>leave blank to send to all corporate
                                emails</b>):
                            </label>
                            <input
                                type="text"
                                id="custom_recipients"
                                name="custom_recipients"
                                value={customRecipients}
                                onChange={(e) => setCustomRecipients(e.target.value)}
                                className="form-control"
                                disabled={loading}
                                placeholder={"(comma-separated emails, leave blank to send to all corporate emails"}
                            />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="provider_name" className="form-label">
                                Provider Name:
                            </label>
                            <input
                                type="text"
                                id="provider_name"
                                name="provider_name"
                                value={formData.provider_name}
                                onChange={handleChange}
                                className={`form-control ${errors.provider_name ? "is-invalid" : ""}`}
                                disabled={loading}
                            />
                            {errors.provider_name && (
                                <div className="invalid-feedback">{errors.provider_name}</div>
                            )}
                        </div>

                        <h4>Nearby Providers</h4>
                        {nearbyProviders.map((provider, index) => (
                            <div key={index} className="mb-3 border p-3 rounded">
                                <h5>Provider {index + 1}</h5>
                                <div className="mb-3">
                                    <label>Name:</label>
                                    <input
                                        type="text"
                                        className={`form-control provider-name-input ${
                                            errors[`provider_name_${index}`] ? "is-invalid" : ""
                                        }`}
                                        value={provider.name}
                                        onChange={(e) => handleProviderChange(index, "name", e.target.value)}
                                        disabled={loading}
                                    />
                                    {errors[`provider_name_${index}`] && (
                                        <div className="invalid-feedback">{errors[`provider_name_${index}`]}</div>
                                    )}
                                </div>
                                <div className="mb-3">
                                    <label>Address:</label>
                                    <input
                                        type="text"
                                        className={`form-control ${
                                            errors[`provider_address_${index}`] ? "is-invalid" : ""
                                        }`}
                                        value={provider.address}
                                        onChange={(e) => handleProviderChange(index, "address", e.target.value)}
                                        disabled={loading}
                                    />
                                    {errors[`provider_address_${index}`] && (
                                        <div className="invalid-feedback">{errors[`provider_address_${index}`]}</div>
                                    )}
                                </div>
                                <div className="mb-3">
                                    <label>Contact:</label>
                                    <input
                                        type="text"
                                        className={`form-control ${
                                            errors[`provider_contact_${index}`] ? "is-invalid" : ""
                                        }`}
                                        value={provider.contact}
                                        onChange={(e) => handleProviderChange(index, "contact", e.target.value)}
                                        disabled={loading}
                                    />
                                    {errors[`provider_contact_${index}`] && (
                                        <div className="invalid-feedback">{errors[`provider_contact_${index}`]}</div>
                                    )}
                                </div>
                                {index > 0 && (
                                    <button
                                        type="button"
                                        className="btn btn-danger"
                                        onClick={() => removeProvider(index)}
                                        disabled={loading}
                                    >
                                        Remove Provider
                                    </button>
                                )}
                            </div>
                        ))}

                        <div className="row">
                            <button
                                type="button"
                                className="btn btn-info col-md-6"
                                onClick={addProvider}
                                disabled={loading}
                            >
                                Add Another Provider
                            </button>

                            <button type="submit" className="btn btn-primary col-md-6" disabled={loading}>
                                {loading ? "Sending..." : "Send Suspension Email"}
                            </button>


                            <button
                                type="button"
                                className="btn btn-secondary col-md-6"
                                onClick={handleReset}
                                disabled={loading}
                            >
                                Clear Form
                            </button>

                        </div>
                    </form>
                </div>
            )}

            {activeTab === "lift" && (
                <div className="tab-content mt-4">
                    <h3>Lift Suspension Form</h3>
                    <form onSubmit={handleLiftSubmit}>

                        <div className="mb-3">
                            <label htmlFor="custom_recipients" className="form-label">
                                Custom Recipients (comma-separated emails, <b>leave blank to send to all corporate
                                emails</b>):
                            </label>
                            <input
                                type="text"
                                id="custom_recipients"
                                name="custom_recipients"
                                value={customRecipients}
                                onChange={(e) => setCustomRecipients(e.target.value)}
                                className="form-control"
                                disabled={loading}
                                placeholder={"(comma-separated emails, leave blank to send to all corporate emails"}
                            />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="lift_provider_name" className="form-label">
                                Provider Name:
                            </label>
                            <input
                                type="text"
                                id="lift_provider_name"
                                name="lift_provider_name"
                                value={liftProvider}
                                onChange={(e) => setLiftProvider(e.target.value)}
                                className={`form-control ${errors.liftProvider ? "is-invalid" : ""}`}
                                disabled={loading}
                            />
                            {errors.liftProvider && (
                                <div className="invalid-feedback">{errors.liftProvider}</div>
                            )}
                        </div>

                        <button type="submit" className="btn btn-primary" disabled={loading}>
                            {loading ? "Sending..." : "Send Lift Email"}
                        </button>
                    </form>
                </div>
            )}
            <div className="mt-4">
              <h3>Sending Logs</h3>
              <ul>
                {sendingLogs.map((log, index) => (
                  <li key={index}>
                    [{log.timestamp}] {log.type} Email to {log.recipient} - {log.subject} ({log.status})
                  </li>
                ))}
              </ul>
            </div>
        </div>
    );
}

export default SendingForm;